import React, { FC, ReactNode } from 'react';
import { CopyOutlined } from '@duxton-web/icons';
import { Button } from '@duxton-web/ui';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import './JsonEditor.css';

interface JsonEditorProps {
  className?: string;
  data?: string;
  actionButtonIcon?: ReactNode;
  onClickActionButton?: () => void;
  readOnly?: boolean;
  height?: string;
  onJsonChange?: (jsString: string) => void;
  wrapEnabled?: boolean;
  debounceChangePeriod?: number;
  onLoad?: (editor) => void;
}

const JsonEditor: FC<JsonEditorProps> = ({
  className = '',
  data = '',
  onClickActionButton,
  actionButtonIcon = <CopyOutlined />,
  readOnly,
  height = '400px',
  onJsonChange = () => {},
  wrapEnabled = false,
  debounceChangePeriod = null,
  onLoad = () => {},
}) => {
  return (
    <div
      className={className}
      style={{
        position: 'relative',
        width: '100%',
      }}
    >
      <AceEditor
        value={data}
        width="100%"
        height={height}
        mode="json"
        fontSize={14}
        className={readOnly ? 'json-editor-read-only' : ''}
        readOnly={readOnly}
        theme="monokai"
        style={{
          borderRadius: 12,
        }}
        onChange={(value) => {
          onJsonChange(value);
        }}
        scrollMargin={[8, 8]}
        wrapEnabled={wrapEnabled}
        setOptions={{
          highlightActiveLine: !readOnly,
          highlightGutterLine: !readOnly,
          printMargin: false,
        }}
        debounceChangePeriod={debounceChangePeriod}
        onLoad={onLoad}
      />
      {actionButtonIcon && (
        <Button
          icon={actionButtonIcon}
          onClick={(e) => {
            e.preventDefault();
            onClickActionButton
              ? onClickActionButton()
              : navigator.clipboard.writeText(data);
          }}
          size="small"
          disabled={false}
          type="secondary"
          shape="circle"
          style={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 2,
          }}
        />
      )}
    </div>
  );
};

export default JsonEditor;
